import axios from "axios";
import config from "app/api/axiosConfig";

export default (token: string) =>
  axios.get(`${process.env.REACT_APP_API_HOST}/admin/user`, config(token));
